<script>
import Drawer from "@/components/drawer";
import VueDropify from "vue-dropify";
import { required, email } from "vuelidate/lib/validators";

// Custom Components
import PageHeader from "@/components/page-header";
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

export default {
  page: {
    title: "brand list",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Drawer,
    PageHeader,
    VueDropify,
  },
  data() {
    return {
      title: "Hotel Brands",
      brands: [],
      openStatusDrawer: false,
      isDataLoading: false,
      brandForm: {
        name: null,
        is_support_membership_rewards: false,
        email: null,
        mobile: null,
        membership_reward_tnc: null,
        rewards_website_join_url: null,
        logo: null,
        favicon_icon: null,
        membership_reward_image: null,
      },
      addNew: false,
      isBtnLoading: false,
      submitted: false,
      options: [
        { text: "Yes", value: true },
        { text: "No", value: false },
      ],
    };
  },
  validations: {
    brandForm: {
      name: { required },
      email: { required, email },
      mobile: { required },
    },
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    this.getBrandedData();
  },
  methods: {
    // Method is used to get brand list data
    async getBrandedData() {
      this.isDataLoading = true;
      try {
        const response = await UserService.getBrandData();
        if (response) {
          this.brands = response;
          this.isDataLoading = false;
        }
      } catch (error) {
        errorHandler(error);
      }
    },
    // Method is used to handle drawer close
    detailer(data) {
      if (data) {
        if (!data.name) {
          this.addNew = true;
        } else {
          this.addNew = false;
          this.brandForm = data;
        }
      }
      this.openStatusDrawer = !this.openStatusDrawer;
    },
    // Method is in use to close drawer
    drawerCloser() {
      this.openStatusDrawer = false;
      this.brandForm = {};
      this.brandForm.is_support_membership_rewards = false;
      this.submitted = false;
    },
    // Method is used to handle change of logo
    logoChange(event) {
      this.brandForm.logo = event[0] == undefined ? null : event[0];
    },
    // Method is used to handle change of  icon
    iconChange(event) {
      this.brandForm.favicon_icon = event[0] == undefined ? null : event[0];
    },
    // Method is used to handle change of reward image
    rewardImage(event) {
      this.brandForm.membership_reward_image =
        event[0] == undefined ? null : event[0];
    },
    // Method is used to add and update brand data
    async handleSubmit() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.brandForm.$touch();
      if (this.$v.brandForm.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        const formData = new FormData();
        formData.append("is_active", 1);
        Object.keys(this.brandForm).map((key) => {
          if (this.brandForm[key] !== null && this.brandForm[key] !== "") {
            formData.append(key, this.brandForm[key]);
            if (key == "favicon_icon") {
              if (typeof this.brandForm.favicon_icon == "string") {
                formData.delete("favicon_icon");
              }
            }
            if (key == "logo") {
              if (typeof this.brandForm.logo == "string") {
                formData.delete("logo");
              }
            }
            if (key == "membership_reward_image") {
              if (typeof this.brandForm.membership_reward_image == "string") {
                formData.delete("membership_reward_image");
              }
            }
          }
          if (key == "membership_reward_image") {
            if (this.brandForm[key] == null) {
              formData.append("membership_reward_image", "");
            }
          }
          if (key == "logo") {
            if (this.brandForm[key] == null) {
              formData.append("logo", "");
            }
          }
          if (key == "favicon_icon") {
            if (this.brandForm[key] == null) {
              formData.append("favicon_icon", "");
            }
          }
        });
        if (this.addNew) {
          try {
            const response = await UserService.addBrandData(formData);
            if (response) {
              this.brands.push(response);
              Middleware.notification("Brand added successfully !!", "success");
              this.submitted = false;
              this.isBtnLoading = false;
              this.openStatusDrawer = !this.openStatusDrawer;
            }
          } catch (error) {
            this.openStatusDrawer = !this.openStatusDrawer;
            this.isBtnLoading = false;
            this.submitted = false;
            errorHandler(error);
          }
        } else {
          try {
            const response = await UserService.editBrandData(
              this.brandForm.id,
              formData
            );
            if (response) {
              this.brands = this.brands.map((brand) => {
                if (brand.id == response.id) {
                  brand = response;
                }
                return brand;
              });
              Middleware.notification(
                "Brand successfully updated !!",
                "success"
              );
              this.submitted = false;
              this.isBtnLoading = false;
              this.openStatusDrawer = !this.openStatusDrawer;
            }
          } catch (error) {
            this.openStatusDrawer = !this.openStatusDrawer;
            this.isBtnLoading = false;
            errorHandler(error);
          }
        }
      }
    },
    // Method is use for update guest premium status
    changeStatus(data, brandID) {
      UserService.editBrandData(data, brandID)
        .then(() => {
          Middleware.notification("Brand status changed !!", "success");
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is use for maintained guest avatar
    avatarGenerator(name) {
      return Middleware.avatarGenerator(name);
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      :action="detailer"
      text="Add New Brand"
      :isButton="true"
    />

    <b-card>
      <div class="table-responsive">
        <table class="table mb-0">
          <thead class="table-light">
            <tr>
              <th class="text-left">Name</th>
              <th class="text-left">Membership Rewards</th>
              <th class="text-left">Status</th>
              <th class="text-left">Actions</th>
            </tr>
          </thead>
          <tbody v-if="isDataLoading">
            <tr v-for="item in 10" :key="item">
              <td class="placeholder-glow" v-for="no in 4" :key="no">
                <span class="placeholder w-100 placeholder-lg"></span>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr
              v-for="brand in brands"
              :key="brand.id"
              @click="detailer(brand)"
            >
              <td>
                <img
                  v-if="brand.logo != null"
                  class="rounded-circle picture-img"
                  :src="brand.logo"
                  alt="Avatar"
                />
                <span v-if="brand.logo != null" class="ms-1">{{
                  brand.name
                }}</span>
                <div
                  v-if="brand.logo == null"
                  class="d-flex align-items-center"
                >
                  <span
                    class="d-flex align-items-center justify-content-center avatar-md-title bg-soft bg-primary text-secondary font-20 rounded-circle picture-img"
                  >
                    {{ avatarGenerator(brand.name) }}
                  </span>
                  <span class="ms-2"> {{ brand.name }}</span>
                </div>
              </td>
              <td class="text-left text-capitalize">
                {{
                  brand.is_support_membership_rewards
                    ? "Available"
                    : "Not Available"
                }}
              </td>
              <td class="text-left">
                <div class="form-check form-switch my-1">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="brand.is_active"
                    @change="
                      changeStatus(brand.id, {
                        is_active: brand.is_active,
                      })
                    "
                  />
                </div>
              </td>
              <td>
                <div class="d-flex align-items-center">
                  <i
                    class="fas fa-pencil-alt text-success fs-5"
                    v-b-popover.hover="'Edit'"
                  ></i>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-card>
    <!-- Detail drawer -->
    <Drawer
      @close="drawerCloser()"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="openStatusDrawer">
        <h4 class="offcanvas-title">
          {{ !addNew ? brandForm.name : "" }}
          {{ addNew ? "Adding A New Brand" : " brand update" }}
        </h4>
        <hr />
        <div class="col-md-12">
          <form ref="brand-form" @submit.stop.prevent="handleSubmit">
            <div class="row">
              <div class="col-sm-6">
                <div class="mb-3">
                  <label for="">brand name </label
                  ><span class="text-danger"> *</span>
                  <b-form-input
                    id="name"
                    name="brand_name"
                    type="text"
                    class="form-control"
                    placeholder="Enter Brand Name"
                    autocomplete="off"
                    v-model="brandForm.name"
                    :class="{
                      'is-invalid': submitted && $v.brandForm.name.$error,
                    }"
                  ></b-form-input>
                  <div
                    v-if="submitted && $v.brandForm.name.$error"
                    class="invalid-feedback"
                  >
                    <span v-if="!$v.brandForm.name.required"
                      >Name is required.</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <label for="">Membership Rewards</label>
                <b-form-select
                  class="form-select"
                  id="company-type-input"
                  :options="options"
                  v-model.trim="brandForm.is_support_membership_rewards"
                >
                </b-form-select>
              </div>
              <div class="col-sm-6">
                <div class="mb-3">
                  <label for="">rewards website join url</label>
                  <input
                    id="name"
                    name="brand_reward_website"
                    type="text"
                    class="form-control"
                    placeholder="Enter Rewards Joining URL"
                    autocomplete="off"
                    v-model.trim="brandForm.rewards_website_join_url"
                  />
                </div>
              </div>
              <div class="col-sm-6">
                <div class="mb-3">
                  <label for="">rewards website url</label>
                  <input
                    id="name"
                    name="brand_name"
                    type="text"
                    class="form-control"
                    placeholder="Enter Reward Website"
                    autocomplete="off"
                    v-model.trim="brandForm.rewards_website_url"
                  />
                </div>
              </div>
              <div class="col-sm-6">
                <div class="mb-3">
                  <label for="">Brand Email</label
                  ><span class="text-danger"> *</span>
                  <input
                    id="email"
                    name="brand_email"
                    type="text"
                    class="form-control"
                    placeholder="Enter Brand Email"
                    autocomplete="off"
                    v-model.trim="brandForm.email"
                    :class="{
                      'is-invalid': submitted && $v.brandForm.email.$error,
                    }"
                  />
                  <div
                    v-if="submitted && $v.brandForm.email.$error"
                    class="invalid-feedback"
                  >
                    <span v-if="!$v.brandForm.email.required"
                      >Email is required.</span
                    >
                    <span v-if="!$v.brandForm.email.email"
                      >Email is not valid.</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="mb-3">
                  <label for="mobile_no">Brand Mobile No</label
                  ><span class="text-danger"> *</span>
                  <vue-tel-input
                    class="text-dark-gray"
                    :validCharactersOnly="true"
                    :defaultCountry="
                      brandForm.mobile_iso ? brandForm.mobile_iso : 'US'
                    "
                    v-model.trim="brandForm.mobile"
                    :class="{
                      'is-invalid': submitted && $v.brandForm.mobile.$error,
                    }"
                    placeholder="Enter Brand Mobile"
                    autocomplete="off"
                  ></vue-tel-input>
                  <div
                    v-if="submitted && $v.brandForm.mobile.$error"
                    class="invalid-feedback"
                  >
                    <span v-if="!$v.brandForm.mobile.required"
                      >Mobile is required.</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-sm-6 mb-2">
                <label for="">logo</label>
                <VueDropify
                  :src="brandForm.logo ? brandForm.logo : ''"
                  @upload="logoChange($event)"
                  message="Drop image here or click to select"
                />
              </div>
              <div class="col-sm-6">
                <label for="">favicon icon</label>
                <VueDropify
                  :src="brandForm.favicon_icon ? brandForm.favicon_icon : ''"
                  @upload="iconChange($event)"
                  message="Drop image here or click to select"
                />
              </div>
              <div class="col-sm-6">
                <label for="">Reward Image</label>
                <VueDropify
                  :src="
                    brandForm.membership_reward_image
                      ? brandForm.membership_reward_image
                      : ''
                  "
                  @upload="rewardImage($event)"
                  message="Drop image here or click to select"
                />
              </div>
              <div class="col-md-12">
                <hr />
                <b-button
                  class="float-end ms-2"
                  variant="outline-primary"
                  type="reset"
                  @click="drawerCloser()"
                  >Cancel</b-button
                >
                <b-button
                  variant="outline-primary"
                  class="float-end"
                  type="submit"
                  :class="{
                    disabled: isBtnLoading,
                  }"
                >
                  <i
                    v-if="isBtnLoading"
                    class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                  ></i>
                  {{ addNew ? "Save" : "Update" }}
                </b-button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </Drawer>
  </div>
</template>
